import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Form, Spinner, Container, Offcanvas, Button } from "react-bootstrap";
import { easeOut, motion } from "framer-motion";
import AnimatedCursor from "react-animated-cursor";

import loaderimgx from "./components/assets/loaderimgx.svg";
import HomePage from "./components/Homepage/HomePage";
import "./components/Homepage/Homepage.css";
import { Routes, Route } from "react-router-dom";
import MySkillsPage from "./components/MySkills/MySkillsPage";
import ExperiencePage from "./components/Experience/ExperiencePage";
import MyBlog from "./components/Blog/MyBlog";
import FormSubmission from "./components/FormSubmission";
import ProjectPage from "./components/Projects/ProjectPage";
import ProjectDetailDynamic from "./components/Projects/ProjectDetailDynamic";

import Adept from "./components/Projects/ProjectFolder/Adept/Adept";

import Edgemarketing from "./components/Projects/ProjectFolder/Edgemarketing/Edgemarketing";
import Notarymeet from "./components/Projects/ProjectFolder/Notarymeet/Notarymeet";

import Olabranding from "./components/Projects/ProjectFolder/Ola/Olabranding";

import Buidl from "./components/Projects/ProjectFolder/buidl/buidl";
import Amabills from "./components/Projects/ProjectFolder/amabills/amabills";
import Budgety from "./components/Projects/ProjectFolder/budgety/budgety";
import Measureme from "./components/Projects/ProjectFolder/measureme/measureme";
import Lodabranding from "./components/Projects/ProjectFolder/Lodabranding/lodabranding";

const Loader = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount(prevCount => {
        if (prevCount < 100) {
          return prevCount + 1;
        }
        clearInterval(interval);
        return 100;
      });
    }, 30); // 10000ms / 100 = 100ms per increment

    return () => clearInterval(interval);
  }, []);

  return (
    <Container
      fluid
      className="loadingpage"
      style={{ width: "100%", height: "100vh", position: "relative" }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <center>
          <img
            className="img-fluid LoaderImage"
            src={loaderimgx}
            alt="abouturbanImage"
          />
          <p
            className="loadingtext"
            style={{
              fontSize: "0.8rem",
              wordSpacing: "0.1rem",
              fontWeight: 500,
              lineHeight: "189%",
              fontFamily: "Jost, sans-serif",
            }}
          >
            I'm a creatively driven and versatile product designer committed to
            crafting exceptional and functional products with great user
            experiences.
          </p>
        </center>
      </motion.div>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        style={{
          position: "absolute",
          bottom: "2rem",
          right: "2rem",
          fontFamily: "Clay Display",
          fontSize: "4rem",
          fontWeight: "bold",
        }}
      >
        <strong><em>{count}%</em></strong>
      </motion.div>
    </Container>
  );
};

const Home = () => (
  <div>
    <HomePage />
  </div>
);

const RootApplication = () => {
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
    
      useEffect(() => {
        const handleResize = () => {
          setIsSmallScreen(window.innerWidth <= 768);
        };
    
        window.addEventListener('resize', handleResize);
    
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);
  

  const validateEmail = (input) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    if (!validateEmail(email)) {
      alert("Please enter a valid email address.");
      setIsLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        "https://formspree.io/f/xknlwkza",
        {
          fullname,
          email,
          message,
        },
        {
          headers: { Accept: "application/json" },
        }
      );

      if (response.status === 200) {
        setFullname("");
        setEmail("");
        setMessage("");
        handleClose();
        navigate("/formsubmission", { replace: true });
      } else {
        throw new Error("Failed to submit form");
      }
    } catch (error) {
      console.error("Form submission error:", error);
      alert("Failed to submit the form. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  

  return (
    <>
      <motion.div
        initial={{ x: -10 }}
        animate={{ x: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Button className="contactbtn" variant="dark" onClick={handleShow}>
          <p
            className="contactcontent"
            style={{ fontFamily: "Jost, sans-serif" }}
          >
            CONTACT
          </p>
        </Button>
      </motion.div>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/mySkill" exact element={<MySkillsPage />} />
        <Route path="/experience" exact element={<ExperiencePage />} />
        <Route path="/blog" exact element={<MyBlog />} />
        <Route path="/formsubmission" exact element={<FormSubmission />} />
        <Route path="/project" exact element={<ProjectPage />} />

        {/* project routing */}
        <Route path="/project/adept" exact element={<Adept />} />
        <Route path="/project/ola" exact element={<Olabranding />} />
        <Route
          path="/project/edgemarketing"
          exact
          element={<Edgemarketing />}
        />
        <Route path="/project/notarymeet" exact element={<Notarymeet />} />
     
        <Route path="/project/buidl" exact element={<Buidl />} />
        <Route path="/project/amabills" exact element={<Amabills />} />
        <Route path="/project/budgety" exact element={<Budgety />} />
        <Route path="/project/measureme" exact element={<Measureme />} />
        <Route path="/project/lodabranding" exact element={<Lodabranding />} />
        <Route path="/project/:slug" exact element={<ProjectDetailDynamic />} />
      </Routes>

      <Offcanvas
        placement="bottom"
        show={show}
        onHide={handleClose}
        className="contactmodal"
      >

         {!isSmallScreen && (
                        <AnimatedCursor
                          innerSize={5}
                          outerSize={36}
                          color='95,95,95'
                          outerAlpha={0.25}
                          innerScale={0.7}
                          outerScale={1.5}
                          outerStyle={{ border: '1.5px solid #4A4A4A' }}
                          innerStyle={{ border: '4px solid #ffffff' }}
                          trailingSpeed={10}
                          clickables={[
                            'a', 'input[type="text"]', 'input[type="email"]', 'input[type="number"]', 'input[type="submit"]',
                            'input[type="image"]', 'label[for]', 'select', 'textarea', 'button', '.link'
                          ]}
                        />
                      )}

      
        

        <Offcanvas.Header closeButton closeVariant="white">
          <Offcanvas.Title
            style={{
              fontSize: "0.7rem",
              color: "#707070",
              fontFamily: "Jost, sans-serif",
            }}
          >
            CONTACT ME
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: -2 }}
            transition={{ duration: 0.3, delay: 0.2, timingFunction: easeOut }}
          >
            <h2
              style={{
                color: "whitesmoke",
                fontWeight: "bold",
                fontFamily: "Clash Display",
              }}
            >
              Get in touch with me
            </h2>
            <p
              style={{
                color: "#FFFFFF",
                fontFamily: "Jost, sans-serif",
                fontSize: "0.8rem",
              }}
            >
              Provide the following details
            </p>
          </motion.div>

          <Form
            onSubmit={handleSubmit}
            style={{ fontFamily: "Jost, sans-serif", fontSize: "0.8rem" }}
          >
            <Form.Group className="mb-3">
              <Form.Label style={{ color: "#FFFFFF" }}>Fullname</Form.Label>
              <Form.Control
                type="text"
                value={fullname}
                onChange={(e) => setFullname(e.target.value)}
                required
                placeholder="Enter your fullname"
                style={{ borderRadius: "0rem" }}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label style={{ color: "#FFFFFF" }}>Email</Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Enter your mail"
                style={{ borderRadius: "0rem" }}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label style={{ color: "#FFFFFF" }}>Message</Form.Label>
              <Form.Control
                as="textarea"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
                placeholder="Enter your message"
                rows={3}
                style={{ borderRadius: "0rem" }}
              />
            </Form.Group>
            <Button
              type="submit"
              className="submitbtn"
              style={{
                paddingLeft: "2rem",
                paddingRight: "2rem",
                fontFamily: "Jost, sans-serif",
              
                borderRadius: "0rem",

                  background:
                      "radial-gradient(70.4% 63.2% at 53.1% 128.2%, rgba(255, 255, 255, 0.23) 0%, rgba(255, 255, 255, 0.04) 100%)",
                    height: "100%",
                  
                    boxShadow:
                      "rgba(255, 255, 255, 0.024) 0px 0.362176px 0.651917px -1px inset, rgba(255, 255, 255, 0.035) 0px 3px 5.4px -2px inset",
                    willChange: "auto",
                    opacity: 1,
                    borderBottomWidth: "2px",
                    borderLeftWidth: "2px",
                    borderRightWidth: "2px",
                    borderTopWidth: "2px",
                    borderColor: "rgba(255, 255, 255, 0.02)",
                    borderStyle: "solid",
              }}
              variant="dark"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  <span
                    style={{
                      fontSize: "0.8rem",
                      marginLeft: "0.3rem",
                      marginRight: "0.3rem",
                    }}
                  >
                    Loading...
                  </span>
                </>
              ) : (
                <span
                  style={{
                    fontSize: "0.8rem",
                    marginLeft: "0.3rem",
                    marginRight: "0.3rem",
                  
                  }}
                >
                  SUBMIT
                </span>
              )}
            </Button>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

const App = () => {
  const hasLoaded = sessionStorage.getItem("hasLoaded");
  const [loading, setLoading] = useState(!hasLoaded);

  useEffect(() => {
    if (!hasLoaded) {
      setTimeout(() => {
        setLoading(false);
        sessionStorage.setItem("hasLoaded", "true");
      }, 5000);
    }
  }, [hasLoaded]);

  // 10000

  return (
    <div className="App" style={{ width: 100 + "%" }}>
      {loading && <Loader />}
      {loading || <RootApplication />}
    </div>
  );
};

export default App;
